import { SHOW_CART_ATC_SLIDER } from '../actionTypes/AtcSliderStatusActionTypes';

const SliderStatusReducer = function SliderStatusReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case SHOW_CART_ATC_SLIDER:
            return action.payload;
        default:
            return state;
    }
};

SliderStatusReducer.reducerName = 'productDetailsSliderStatus';

export default SliderStatusReducer;
